import { render, staticRenderFns } from "./SeccionProcesamientoPage.vue?vue&type=template&id=5f77927d"
import script from "./SeccionProcesamientoPage.js?vue&type=script&lang=js&external"
export * from "./SeccionProcesamientoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports